import React from "react";

interface GlossaryDefinitionProps {
  definition: string | undefined;
}

export function GlossaryDefinition({ definition }: GlossaryDefinitionProps) {
  // Split the definition by ||PARAGRAPH|| to create paragraphs
  const paragraphs = definition?.split("\n\n") || [];

  if (!definition || paragraphs.length === 0) {
    return <p className="text-gray-500 italic">No definition available.</p>;
  }

  return (
    <div className="space-y-4">
      {paragraphs.map((paragraph, index) => {
        // Handle line breaks within paragraphs
        const lines = paragraph.split("\n");

        return (
          <p key={index} className="text-gray-700 leading-relaxed">
            {lines.map((line, lineIndex) => (
              <React.Fragment key={lineIndex}>
                {line.trim()}
                {lineIndex < lines.length - 1 && <br />}
              </React.Fragment>
            ))}
          </p>
        );
      })}
    </div>
  );
}
